import { Image } from 'antd';
import { getApi } from 'apis';
import { getViewComboFields } from 'constants/Data';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';
import styles from '../../Medicines/ViewGroceriesBody/index.module.scss';

const resolveImageSrc = (url: string) => {
  if (!url) return '/assets/images/noImage.png';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${process.env.REACT_APP_S3_BASE_URL}${url}`;
};

const ViewComboBody = ({ combo }: { combo: any }) => {
  const [detail, setDetail] = useState<any>(combo);
  const [subCategoryName, setSubCategoryName] = useState<string | null>(
    combo?.subCategoryName ?? null,
  );

  const userProfile = useSelector((state: any) => state?.userProfile);

  const canViewImages = checkPermission(userProfile?.data?.permissions, {
    permissionName: 'Images',
    permission: ['view'],
  });

  useEffect(() => {
    setDetail(combo);
    setSubCategoryName(combo?.subCategoryName ?? null);
  }, [combo]);

  useEffect(() => {
    const loadDetail = async () => {
      if (!combo?.id) return;
      try {
        const res = await getApi(`/combo/${combo.id}`);
        const item = res?.data?.data;
        if (item) {
          setDetail(item);
          setSubCategoryName(item.subCategoryName ?? null);
        }
      } catch {
        // use list row if detail fetch fails
      }
    };
    loadDetail();
  }, [combo?.id]);

  useEffect(() => {
    if (detail?.subCategoryName) {
      setSubCategoryName(detail.subCategoryName);
      return;
    }
    if (!detail?.categoryId || !detail?.subCategoryId) return;

    const fetchCategory = async () => {
      try {
        const data = await getApi(
          `/combo-category/get-category/${detail.categoryId}`,
        );
        const categoryData = data.data?.data;
        const matched = categoryData?.subCategories?.find(
          (sub: { id: string; name: string }) => sub.id === detail.subCategoryId,
        );
        setSubCategoryName(matched?.name ?? null);
      } catch {
        // ignore
      }
    };
    fetchCategory();
  }, [detail?.categoryId, detail?.subCategoryId, detail?.subCategoryName]);

  const fields = getViewComboFields(
    detail,
    detail?.categoryName,
    subCategoryName,
  );
  const secondaryImages = detail?.comboSecondaryImageUrl || [];

  return (
    <div className={styles['side-drawer-body']}>
      <div className={styles['side-drawer-form']}>
        <div className={styles['side-drawer-form__inputs']}>
          {fields.map((field, index) => (
            <div className={styles['input-group']} key={index}>
              <label>{field.label}</label>
              <span />
              <p>{field.value ?? field.value === 0 ? String(field.value) : '-'}</p>
            </div>
          ))}
        </div>

        {canViewImages && (
          <div className={`${styles['input-group']} ${styles['image-row']}`}>
            <label>Images</label>
            <div className={styles['images-container']} style={{ display: 'flex', gap: 20 }}>
              <div>
                <p>Primary Image</p>
                <Image
                  src={resolveImageSrc(detail?.comboPrimaryImageUrl)}
                  alt="Primary"
                  width={100}
                />
              </div>
              {secondaryImages.length > 0
                ? secondaryImages.slice(0, 3).map((url: string, index: number) => (
                    <div key={index}>
                      <p>Secondary {index + 1}</p>
                      <Image
                        src={resolveImageSrc(url)}
                        alt={`Secondary ${index}`}
                        width={100}
                      />
                    </div>
                  ))
                : [1, 2, 3].map((_, index) => (
                    <div key={index}>
                      <p>Secondary {index + 1}</p>
                      <img
                        src="/assets/images/noImage.png"
                        alt={`Secondary ${index}`}
                        width={100}
                      />
                    </div>
                  ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewComboBody;
